// ─── Search suggestion models ───────────────────────────────────────────────
// One flat list drives the autocomplete dropdown; each entry renders in its
// own result column (specialities / doctors).
// NOTE: BlogSuggestion is kept for a future re-add of the blogs column;
// it is intentionally not part of the AutocompleteSuggestion union for now.

export interface SpecialitySuggestion {
  type: 'speciality';
  slug: string;
  title: string;
  url: string;
}

export interface DoctorSuggestion {
  type: 'doctor';
  slug: string;
  fullName: string;
  heading?: string;
  primarySpeciality?: string;
  specialities?: string[];
  url: string;
}

export interface BlogSuggestion {
  type: 'blog';
  key: string;
  title: string;
  author?: string;
  speciality?: string;
  url: string;
}

export type AutocompleteSuggestion = SpecialitySuggestion | DoctorSuggestion;

export interface HeroSearchBarProps {
  inputPlaceholder?: string;
  searchButtonLabel?: string;
}

/** Stable DOM id for keyboard navigation (`aria-activedescendant`). */
export const getOptionId = (s: AutocompleteSuggestion): string =>
  `option-${s.type}-${encodeURIComponent(s.slug)}`;
